import { afterAnswerWrites, biletlarCache } from '@/api/answerWrites';
import { type Lang, type List, request, withPicture } from '@/api/client';
import type { Question } from '@/api/questions';
import { BILET, checked } from '@/api/shape';

export interface BiletSummary {
  number: number;
  question_count: number;
  status: 'new' | 'passed' | 'failed';
  best_score: number | null;
  last_attempt_at: string | null;
}

export type BiletsList = List<BiletSummary>;

export interface BiletQuestion extends Question {
  position: number;
}

export interface Bilet {
  number: number;
  question_count: number;
  questions: BiletQuestion[];
  best_score: number | null;
}

export function getBiletlar(): Promise<BiletsList> {
  return biletlarCache.get('', () => afterAnswerWrites(() => request<BiletsList>('/biletlar')));
}

export function getBilet(number: number, lang: Lang): Promise<Bilet> {
  return request<unknown>(`/biletlar/${number}?lang=${lang}`)
    .then(checked<Bilet>(BILET, 'bilet'))
    .then((bilet) => ({
      ...bilet,
      questions: bilet.questions.map(withPicture),
    }));
}
